type KV = { [key: string]: string }

export function copyWithout(src: KV, exclude: string) {
    let result: KV = {};
    for (let prop in src) {
        if(prop !== exclude) {
            result[prop] = src[prop]
        }
    }
    return result;
}